import { SrIcon } from "@/components/ui/SrIcon";
import type { InvoiceWithProject } from "@/hooks/use-invoices";

interface InvoicePdfButtonProps {
  invoice: InvoiceWithProject;
  opening: boolean;
  onOpen: (invoiceId: string) => void;
}

/** Åpner faktura-PDF fra PowerOffice; nedtonet når fakturaen ikke finnes i PO. */
export function InvoicePdfButton({ invoice, opening, onOpen }: InvoicePdfButtonProps) {
  if (!invoice.poweroffice_invoice_id) {
    return (
      <span className="inline-grid place-items-center w-8 h-8 opacity-30" title="Ingen PDF tilgjengelig">
        <SrIcon name="file-text" className="w-4 h-4 text-muted-foreground" />
      </span>
    );
  }
  return (
    <button
      type="button"
      onClick={() => onOpen(invoice.id)}
      disabled={opening}
      className="inline-grid place-items-center w-8 h-8 rounded-md text-muted-foreground hover:text-primary hover:bg-muted disabled:opacity-50"
      title="Åpne faktura-PDF fra PowerOffice"
      aria-label={`Åpne PDF for faktura ${invoice.invoice_no ?? invoice.id}`}
    >
      <SrIcon name={opening ? "loader2" : "file-text"} className={opening ? "w-4 h-4 animate-spin" : "w-4 h-4"} />
    </button>
  );
}
